var _a;
export var OrgConfigStep;
(function (OrgConfigStep) {
    OrgConfigStep[OrgConfigStep["Locations"] = 0] = "Locations";
    OrgConfigStep[OrgConfigStep["Hours"] = 1] = "Hours";
    OrgConfigStep[OrgConfigStep["StaffSettings"] = 2] = "StaffSettings";
    OrgConfigStep[OrgConfigStep["Shrinkage"] = 3] = "Shrinkage";
    OrgConfigStep[OrgConfigStep["SupportRoles"] = 4] = "SupportRoles";
    OrgConfigStep[OrgConfigStep["Financials"] = 5] = "Financials";
    OrgConfigStep[OrgConfigStep["ClientsLobs"] = 6] = "ClientsLobs";
    OrgConfigStep[OrgConfigStep["Seats"] = 7] = "Seats";
    OrgConfigStep[OrgConfigStep["Review"] = 8] = "Review";
})(OrgConfigStep || (OrgConfigStep = {}));
export var ORG_CONFIG_STEPS = [
    OrgConfigStep.Locations,
    OrgConfigStep.Hours,
    OrgConfigStep.StaffSettings,
    OrgConfigStep.Shrinkage,
    OrgConfigStep.SupportRoles,
    OrgConfigStep.Financials,
    OrgConfigStep.ClientsLobs,
    OrgConfigStep.Seats,
    OrgConfigStep.Review,
];
export var STEP_NAME = (_a = {},
    _a[OrgConfigStep.Locations] = 'locations',
    _a[OrgConfigStep.Hours] = 'hours',
    _a[OrgConfigStep.StaffSettings] = 'staffSettings',
    _a[OrgConfigStep.Shrinkage] = 'shrinkage',
    _a[OrgConfigStep.SupportRoles] = 'supportRoles',
    _a[OrgConfigStep.Financials] = 'financials',
    _a[OrgConfigStep.ClientsLobs] = 'clientsLobs',
    _a[OrgConfigStep.Seats] = 'seats',
    _a[OrgConfigStep.Review] = 'review',
    _a);
/** Steps that need a resolved selectedLocationId */
export var LOCATION_SCOPED_STEPS = [
    OrgConfigStep.Hours,
    OrgConfigStep.StaffSettings,
    OrgConfigStep.Shrinkage,
    OrgConfigStep.SupportRoles,
    OrgConfigStep.Financials,
    OrgConfigStep.Review,
];
export var MAX_TEXT_LENGTH = 35;
export var MASKED_SECRET = '•'.repeat(43);
